import React, {KeyboardEvent, useState} from 'react';
import SearchIcon from "../../../../ui/svg/common/search";
import MobileMenuIcon from "../../../../ui/svg/common/mobile-menu";
import {EVENT_LIST_MENU_MOBILE_OPEN} from "../../../menus/list-menu/services/list-menu-provider";
import {useWindowSize} from "../../../../domain/common";


const SupportSearch = () => {

    const [inputValue, setInputValue] = useState("");
    // Window size hook
    const size = useWindowSize();
    const MAX_MOBILE_WIDTH = 500;

    /**
     * handle key up event - query search on Enter
     */
    const handleKeyUp = async (evt: KeyboardEvent) => {

        if(evt.key === 'Enter') {
            await Search();
        }
    };

    /**
     * handle search action on page number 1
     */
    const Search = async () => {
        window.location.href =  "/support/search?q=" + inputValue
    };

    const openMobileMenu = () => {
        document.dispatchEvent(new Event(EVENT_LIST_MENU_MOBILE_OPEN));
    }


    const isMobileMenuIconVisible = window.location.pathname.startsWith('/support/tag/');

    return (
        <div className="w-full overflow-hidden" >
            <div className={`w-full flex items-center justify-center`}>

                {
                    isMobileMenuIconVisible &&
                    <div className="lg:hidden pr-4 w-fit" onClick={() => openMobileMenu()}>
                        <MobileMenuIcon width={`${size.width !== undefined && size.width > MAX_MOBILE_WIDTH ? "57px" : "46px"}`} color="#F8F9FB" />
                    </div>
                }

                <div className="w-full border border-gray-200-ho bg-gray-100 outline-none rounded-full flex items-center justify-center">
                    <input
                        type="text"
                        className="w-full rounded-full flex-1 p-3 pl-4 md:p-2 md:pl-6 outline-none xl:pl-8 bg-gray-100"
                        value={ inputValue}
                        placeholder="Search Waves Support"
                        onKeyUp={ async evt => {
                            await handleKeyUp(evt);
                        }}
                        aria-label="Search Support"
                        onChange={evt => {
                            setInputValue(evt.target.value);
                        }}
                    />
                    <div className="p-3 md:p-5 pr-4 xl:pr-8 cursor-pointer" onClick={Search}>
                        <SearchIcon width="15px" color="#252525" title="Filter" />
                    </div>
                </div>
            </div>


        </div>



    )
};

export default SupportSearch;